export enum WiseRecipientStatusEnum {
    Active = 'active',
    Inactive = 'inactive',
}
